import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'

import {Stack} from '@salesforce/retail-react-app/app/components/shared/ui'

import SearchField from './search-field'
import SearchByLocation from './search-by-location'

const Search = ({setStores, setHideNoSearchResults}) => {
    const [searchTerm, setSearchTerm] = useState('')
    const [showPermissionError, setShowPermissionError] = useState(false)

    useEffect(() => {
        const previousSearch = localStorage.getItem('storesSearchTerm')
        if (previousSearch) setSearchTerm(previousSearch)
    }, [])

    return (
        <Stack gap="10px" marginTop="16px" marginBottom="5px">
            <SearchField
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                setHideNoSearchResults={setHideNoSearchResults}
                setStores={setStores}
                setShowPermissionError={setShowPermissionError}
            />
            <SearchByLocation
                setSearchTerm={setSearchTerm}
                setStores={setStores}
                showPermissionError={showPermissionError}
                setShowPermissionError={setShowPermissionError}
            />
        </Stack>
    )
}

Search.propTypes = {
    setStores: PropTypes.func.isRequired,
    setHideNoSearchResults: PropTypes.func.isRequired,
    hideNoSearchResults: PropTypes.func.isRequired
}

export default Search
